module.exports = __webpack_public_path__ + "static/media/Landcruiser-120-LC.3b201d48.webp";